<template>
  <div class="check_data">
    <div class="check_one">
      <div class="padding_left">
        <span class="font_size">选择用户：</span>
        <el-select v-model="changeUser" placeholder="请选择">
          <el-option
            v-for="(item,index) in listUsers"
            :key="index"
            :label="item.username"
            :value="item.username">
          </el-option>
        </el-select>
      </div>
      <div class="padding_left">
        <span class="font_size">选择生产单元：</span>
        <el-select v-model="changeCell" placeholder="请选择">
          <el-option
            v-for="(item,index) in listCells"
            :key="index"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="padding_left">
        <span class="font_size">选择传感器：</span>
        <el-select v-model="changeSensor" placeholder="请选择">
          <el-option
            v-for="(item,index) in listSensors"
            :key="index"
            :label="item.name"
            :value="item.name">
          </el-option>
        </el-select>
      </div>
      <div class="padding_left">
        <span class="font_size">选择参数：</span>
        <el-select v-model="changeParams" placeholder="请选择">
          <el-option
            v-for="(item,index) in listParams"
            :key="index"
            :label="item.typeCHN"
            :value="item.snpid">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="check_two">
      <div class="query_time">
        <div class="real_play">
          实时数据：
          <div
            class="query_real_time"
            v-for="(real,index) in real_data"
            :key="index"
            v-if="changeParams === real.snpid">
            <div>{{real.value}}<span style="margin-left: 5px;">{{suffix}}</span></div>
          </div>
        </div>
        <div class="query_history_time">
          时间选择：
          <el-date-picker
            v-model="his_time"
            type="datetimerange"
            :picker-options="pickerOptions"
            align="right"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['12:00:00', '08:00:00']">
          </el-date-picker>
        </div>
      </div>
      <div class="hisQurey" ref="hisQurey" :style="{width: curWidth, height:'470px'}"></div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      listUsers: [],
      listCells: [],
      listSensors: [],
      listParams: [],
      changeUser: '',
      changeCell: '',
      changeSensor: '',
      changeParams: '',
      real_data: {},
      real_name: [],
      his_data: {},
      his_data_x: [],
      his_data_y: [],
      his_time: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一天',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', [start, end])
            // this.his_time = [start, end]
          }
        }, {
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
            // this.his_time = [start, end]
          }
        }, {
          text: '最近一月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
            // this.his_time = [start, end]
          }
        }, {
          text: '最近半年',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180)
            picker.$emit('pick', [start, end])
            // this.his_time = [start, end]
          }
        }]
      },
      token: window.sessionStorage.getItem('token'),
      suffix: '',
      curWidth: ''
    }
  },
  methods: {
    // 获取 所有用户信息
    getAllusers () {
      this.listUsers = []
      this.axios.get(this.$store.state.loginIp + 'admin/lists',
        {
          params: {'pageSize': 100, 'role': '2'},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        this.listUsers = res.data.data.list
      }).catch(err => {
        console.log(err)
      })
    },
    // 获取 用户的生产单元信息
    getAllCells () {
      this.axios.get(this.$store.state.ip + 'celldef/listUserCells',
        {
          params: {'username': this.changeUser, 'pageSize': 30},
          headers: {'Authorization': 'Bearer ' + window.sessionStorage.getItem('token')}
        }).then(res => {
        this.listCells = res.data.data.list
      }).catch(err => {
        console.log(err)
      })
    },
    // 获取 该用户下的所有传感器信息
    getAllsensors () {
      this.listSensors = []
      this.axios.get(this.$store.state.ip + 'sensordef/cellSensors',
        {
          params: {'cell_id': this.changeCell, 'pageSize': 30},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        this.listSensors = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
    // 获取 该传感器下的环境参数
    getAllparams () {
      this.listParams = []
      this.axios.get(this.$store.state.ip + 'sensordef/cellParams',
        {
          params: {'cell_id': this.changeCell},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        for (let i = 0; i < res.data.data.length; i++) {
          if (res.data.data[i].name === this.changeSensor) {
            this.listParams = this.listParams.concat(res.data.data[i])
          }
        }
        for (let i = 0; i < this.listParams.length; i++) {
          this.listParams[i].snpid = this.listParams[i].snpid.toString()
        }
        this.real_time()
      }).catch(err => {
        console.log(err)
      })
    },
    // 实时数据
    real_time () {
      this.axios.get(this.$store.state.ip + 'opt/rtQuery',
        {
          params: {'cell_id': this.changeCell},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        this.real_data = res.data.data
        for (let i = 0; i < this.real_data.length; i++) {
          this.real_data[i].snpid = this.real_data[i].snpid.toString()
          if (this.real_data[i].snpid === this.changeParams) {
            this.real_name = this.real_name.concat(this.real_data[i])
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 历史数据
    drawLine () {
      this.his_data_x = []
      this.axios.get(this.$store.state.ip + 'opt/hisQuery',
        {
          params: {'cell_id': this.changeCell, 'start_time': this.his_time[0], 'end_time': this.his_time[1]},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        for (let i = 0; i < res.data.data.length; i++) {
          for (let j = 0; j < res.data.data[i].sntvs.length; j++) {
            if (this.changeParams === res.data.data[i].sntvs[j].snpid.toString()) {
              this.his_data = res.data.data[i].sntvs[j]
              break
            }
          }
        }
        for (let i = 0; i < this.his_data.times.length; i++) {
          this.his_data.times[i] = this.resetTime(this.his_data.times[i] * 1000)
        }
        // 打印 历史数据
        let mycharts = this.$echarts.init(this.$refs.hisQurey)
        mycharts.setOption({
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          color: ['#91c7ae'],
          grid: {
            left: '3%',
            right: '4%',
            bottom: '4%',
            containLabel: true
          },
          dataZoom: [
            {
              show: true,
              realtime: true,
              start: 0
              // end: 25 / this.his_data_x.length * 100
            },
            {
              type: 'inside',
              realtime: true,
              start: 0,
              end: 100
            }
          ],
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: this.his_data.times
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: [
            {
              name: '历史数据',
              type: 'line',
              stack: '总量',
              itemStyle: {
                normal: { // 背景色渐变
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0, color: '#aed4c2'
                  }, {
                    offset: 0.5, color: 'rgba(174, 212, 194, 0.5)'
                  }, {
                    offset: 0.85, color: '#fff'
                  }]),
                  lineStyle: { // 折线样式
                    width: 2.5,
                    type: 'solid',
                    color: '#91c7ae' // 拆线颜色
                  }
                },
                emphasis: {
                  color: '#91c7ae',
                  lineStyle: {
                    type: 'dotted',
                    color: '#91c7ae'
                  }
                }
              },
              label: {
                normal: {
                  show: true,
                  position: 'top'
                }
              },
              symbolSize: 5,
              areaStyle: {
                normal: {}
              },
              data: this.his_data.values
            }
          ]
        })
      }).catch(err => {
        console.log(err)
      })
    },
    // 时间戳转换为标准时间
    resetTime (time) {
      let test = new Date(time)
      let year = test.getFullYear() // 取得4位数的年份
      let month = ('0' + (test.getMonth() + 1)).slice(-2) // 取得日期中的月份，其中0表示1月，11表示12月
      let date = ('0' + test.getDate()).slice(-2) // 返回日期月份中的天数（1到31）
      let hour = ('0' + test.getHours()).slice(-2) // 返回日期中的小时数（0到23）
      let minute = ('0' + test.getMinutes()).slice(-2) // 返回日期中的分钟数（0到59）
      let second = ('0' + test.getSeconds()).slice(-2) // 返回日期中的秒数（0到59）
      return year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
    },
    // 标准时间 转换为 yyyy:mm:dd hh:mm:ss
    changeTime (time) {
      const resDate = time.getFullYear() + '-' + this.p((time.getMonth() + 1)) + '-' + this.p(time.getDate())
      const resTime = this.p(time.getHours()) + ':' + this.p(time.getMinutes()) + ':' + this.p(time.getSeconds())
      return resDate + ' ' + resTime
    },
    p (s) {
      return s < 10 ? '0' + s : s
    }
  },
  created () {
    this.getAllusers()
    this.curWidth = document.body.clientWidth - 260 + 'px'
  },
  watch: {
    'changeUser': function () {
      this.listCells = []
      this.getAllCells()
    },
    'changeCell': function () {
      this.getAllsensors()
    },
    'changeSensor': function () {
      this.getAllparams()
    },
    'changeParams': function () {
      for (let i = 0; i < this.listParams.length; i++) {
        if (this.changeParams === this.listParams[i].snpid) {
          this.suffix = this.listParams[i].suffix
        }
      }
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24)
      this.his_time = [this.changeTime(start), this.changeTime(end)]
      // this.drawLine()
    },
    'his_time': function () {
      this.drawLine()
    }
  }
}
</script>

<style scoped>
.check_one {
  display: flex;
  justify-content: left;
  align-items: center;
  height: 60px;
  background-color: white;
  border-radius: 4px;
}
.padding_left{
  padding-left: 20px;
}
.font_size {
  font-size: 14px;
  font-weight: 400;
}
.check_two {
  background-color: white;
  margin-top: 20px;
  padding: 20px;
}
.query_time {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: -20px;
}
.real_play {
  display: flex;
  justify-content: left;
  align-items: center;
}
.query_real_time {
  text-align: left;
  padding-left: 10px;
  padding-right: 30px;
  font-size: 16px;
}
.query_history_time {
  text-align: right;
}
.hisQurey{
  margin: 0 auto;
  padding-bottom: 15px;
}
.el-select {
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  width: 145px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/checkData.vue